export default {
    url: '/usage_by_dau',
    template: require('./view.html'),
    data: {
        title: 'Usage By DAU',
        role: 'video',
        priority: 800,
    },
    reloadOnSearch: false,
};
